import { pharmacyProfileActions } from '../../../../actions/user/pharmacy/Profile/profile';

const initialState = {
  isAuthenticated: false,
  user: {},
  profileCompletion: 0,
  loading: false,
  error: null
};

const pharmacyProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case pharmacyProfileActions.FETCH_PHARMACY.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case pharmacyProfileActions.FETCH_PHARMACY.SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload || {},
        profileCompletion: action.payload?.profile_completion ?? state.profileCompletion
      };
    case pharmacyProfileActions.FETCH_PHARMACY.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case pharmacyProfileActions.UPDATE_PHARMACY.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case pharmacyProfileActions.UPDATE_PHARMACY.SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: { ...state.user, ...(action.payload || {}) },
        profileCompletion: action.payload?.profile_completion ?? state.profileCompletion
      };
    case pharmacyProfileActions.UPDATE_PHARMACY.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case pharmacyProfileActions.COMPLETE_PHARMACY.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case pharmacyProfileActions.COMPLETE_PHARMACY.SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload || {},
        profileCompletion: action.payload?.profile_completion ?? 0
      };
    case pharmacyProfileActions.COMPLETE_PHARMACY.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default pharmacyProfileReducer;
